module.exports = __webpack_public_path__ + "img/xtube.ef82008.png";